import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DomSanitizer } from '@angular/platform-browser';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { PieChartConfig } from '../GCharts/PieChartConfig';



import { ReportePagosEfectuados } from '../Models/ReportePagosEfectuados';
import { Usuario } from '../Models/Usuario';
import {TipoTarea } from '../Models/TipoTarea';



import { GlobalsService } from '../services/globals.service';
import { UsuarioService } from '../services/usuario.service';
import { ViajeService } from '../services/viaje.service';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';
import { VisitaTareaService } from '../services/visita-tarea.service';

@Component({
  selector: 'app-reporte-pagos-efectuados',
  templateUrl: './reporte-pagos-efectuados.component.html',
  styleUrls: ['./reporte-pagos-efectuados.component.css']
})
export class ReportePagosEfectuadosComponent implements OnInit {



  public reportePagosEfectuado: ReportePagosEfectuados = new ReportePagosEfectuados();
  public reportePagosEfectuados: ReportePagosEfectuados[];

  public fechaInicio: Date;
  public fechaFin: Date;
  public numeroDocumento: string;
  public codigoCliente: string;
  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public tipoTarea: TipoTarea = new TipoTarea();
  public tipoTareas: TipoTarea[];


  constructor(private globalServices: GlobalsService,
    private usuarioService: UsuarioService, private viajeService: ViajeService,
    private generadorTemprate: GeneradorTemplateService,
    private utilesService: UtilesService,
    private visitaTareaService:VisitaTareaService) {

  }

  ngOnInit() {
    this.CargarUsuarios();
    this.CargarTiposTareas();
  }


  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }


  CargarReportePagoEfectuados() {

    try {

      if (this.usuario.idUsuario === undefined || this.usuario.idUsuario === "") {
        this.usuario.idUsuario = null;
      }

      if (this.numeroDocumento === undefined || this.numeroDocumento === "") {
        this.numeroDocumento = null;
      }

      if (this.fechaInicio === undefined || this.fechaInicio.toString() === "") {
        this.fechaInicio = undefined;
      }

      if (this.fechaFin === undefined || this.fechaFin.toString() === "") {
        this.fechaFin = undefined;
      }

      if (this.codigoCliente === undefined || this.codigoCliente === "") {
        this.codigoCliente = null;
      }

      if (this.tipoTarea.tipo === undefined || this.tipoTarea.tipo === "") {
        this.tipoTarea.tipo = null;
      }

      this.viajeService.ObtenerReportePagosEfectudos(this.globalServices.ObtenerCompania(),
       this.usuario.idUsuario, this.fechaInicio, this.fechaFin, this.numeroDocumento, 
       this.codigoCliente, this.tipoTarea.tipo).subscribe(
        data => {
          this.reportePagosEfectuados = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }


  /**
   * Convierte la tabla asignada en un exel
   * @param tableID 
   * @param filename 
   */
  exportTableToExcel(tableID, filename = '') {
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }

  GenerarExcel() {

    if (this.reportePagosEfectuados === undefined) {
      return;
    }

    //nombre que va a tener el archivo
    var nombre = "reporteNivelServicio.csv";
    var archivo = this.utilesService.getURLReportes() + nombre;

    this.generadorTemprate.GeneradoExcel(this.globalServices.ObtenerCompania(), this.reportePagosEfectuados).subscribe(
      data => {
        //abre el archivo de la carpeta
        var link = document.createElement("a");
        link.download = "reporteNivelServicio";
        link.target = "_blank";
        link.href = archivo; 
        link.click();

      },
      err => {
        console.clear();
        console.log(err._body);

      });

  }


  CargarTiposTareas() {
    try {
     

      this.visitaTareaService.ObtenerTipoTareas().subscribe(
          data => {
            this.tipoTareas = data;

          },
          err => {
            console.clear();
            console.log(err._body);

          });


    } catch (error) {
      console.log("CargarTiposTareas: " + error);
    }

  }

}
